var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3185 22.1093V13.8966H17.1279L17.5494 10.695H14.3185V8.65129C14.3185 7.72465 14.5798 7.09316 15.9361 7.09316L17.6631 7.09246V4.22886C17.3644 4.19079 16.3392 4.10352 15.146 4.10352C12.6543 4.10352 10.9485 5.59526 10.9485 8.33421V10.695H8.13062V13.8966H10.9485V22.1093H14.3185Z",
    fill: "#6B767F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_925_6368",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 4,
    width: 10,
    height: 19
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3185 22.1093V13.8966H17.1279L17.5494 10.695H14.3185V8.65129C14.3185 7.72465 14.5798 7.09316 15.9361 7.09316L17.6631 7.09246V4.22886C17.3644 4.19079 16.3392 4.10352 15.146 4.10352C12.6543 4.10352 10.9485 5.59526 10.9485 8.33421V10.695H8.13062V13.8966H10.9485V22.1093H14.3185Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_925_6368)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.81c94175abd8f9e97fd872971a9e9cc1.svg";
export { ForwardRef as ReactComponent };